'use client';

export { ErrorPage as default } from '@svs/nova-foundation/nextjs/pages';
